<template>
	<div>
		<div class="page-title"><span>{{$store.state.lang.text.promotion[$store.state.lang.language]}}</span></div>
		<div class="md-layout" style="background-color: var(--primary-color); border-radius: 0 0 15px 15px;padding: 15px 0;">

			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-25 only-mobile" v-for="(promotion, index) in mobile">
				<div class="promotion-container">
					<div class="promotion-image-cover">
						<img :src="promotion.image">
					</div>
					<div class="promotion-title">
						<span>{{promotion.text}}</span>
					</div>
				</div>
				<!-- {{proto}} -->
			</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-33 md-size-25 only-web" v-for="(promotion, index) in web">
				<div class="promotion-container">
					<div class="promotion-image-cover">
						<img :src="promotion.image">
					</div>
					<div class="promotion-title">
						<span>{{promotion.text}}</span>
					</div>
				</div>
			</div>

			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="text-align: center">
				<div class="create__btn"><router-link class="cmn--btn" to="/page/promotions" style="cursor: pointer;"><span>បង្ហាញបន្ថែម</span></router-link></div>
			</div>
		</div>


		<div class="content" style="background-color: var(--primary-color); border-radius: 15px;padding: 20px 0px;margin-top: 15px">
			<router-view></router-view>
		</div>
	</div>

</template>

<script>

	export default {
		components: {

		},
		mounted() {
			window.scrollTo(0,0);
		},
		created() {

			// if(this.$store.state.authentication.loggedIn) {
			// 	this.$router.push("/");
			// }  else {
			// 	this.getForm();
			// }
			// var self=this;
			this.mobile = this.shuffle(this.promotions).slice(0,1);
			this.web = this.shuffle(this.promotions).slice(0,4);
			this.interval = setInterval(() => {
				// console.log(this.promotions);
				this.mobile = this.shuffle(this.promotions).slice(0,1);
				this.web = this.shuffle(this.promotions).slice(0,4);
			}, 4000)

		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		computed: {
			// getMobile: function() {
			// 	return this.promotions.slice(0,1);
			// },
			// getWeb: function() {
			// 	return this.promotions.slice(0,4);
			// }
		},
		methods: {
			getForm() {
				this.$http.get(this.config.api + "/user/request_form").then(res => {
					if (res.body.status == 'success') {
						this.loaded = true;
						this.user.token = res.body.data.token
						this.user.code = res.body.data.code
					}
				})
			},
			shuffle(array) {
				for (var i = array.length - 1; i > 0; i--) {
					var j = Math.floor(Math.random() * (i + 1));
					var temp = array[i];
					array[i] = array[j];
					array[j] = temp;
				}
				return array;
			}
		},
		data() {
			return {
				interval: null,
				mobile: [],
				web: [],
				promotions: [
					{id: 2,text: "អតិថិជនថ្មីទទួលបាន $9 ភ្លាមៗ", image: "/promotions/free-9.jpg", term: 1},
					{id: 3, text: "ប្រាក់បន្ថែម 100% សម្រាប់កីឡា", image: "/promotions/100-sport.jpg", term: 2},
					{id: 4, text: "ប្រាក់បន្ថែម 100% សម្រាប់កីឡានិម្មិត", image: "/promotions/100-esport.jpg", term: 2},
					{id: 5, text: "ប្រាក់បន្ថែម 100% សម្រាប់កាស៊ីណូផ្សាយផ្ទាល់ និងជល់មាន់", image: "/promotions/100-casino-cock.jpg", term: 2},
					{id: 6, text: "ប្រាក់បន្ថែម 100% សម្រាប់ស្លត់ហ្គេម", image: "/promotions/100-slot.jpg", term: 2},
					{id: 7, text: "ប្រាក់បន្ថែម 100% សម្រាប់ហ្គេមបាញ់ត្រី", image: "/promotions/100-fishing.jpg", term: 2},
					{id: 8, text: "ប្រាក់បន្ថែម 100% សម្រាប់ឡូតូ", image: "/promotions/100-keno.jpg", term: 2},
					{id: 18, text: "ការផ្តល់ជូន $20 ទទួលបាន $50 សម្រាប់ឡូតូ", image: "/promotions/20-50.jpg", term: 6},
					{id: 11, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់កីឡា", image: "/promotions/10-sport.jpg", term: 4},
					{id: 12, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់កីឡានិម្មិត", image: "/promotions/10-esport.jpg", term: 4},
					{id: 13, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់កាស៊ីណូផ្សាយផ្ទាល់ និងជល់មាន់", image: "/promotions/10-casino-cock.jpg", term: 4},
					{id: 14, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ស្លត់ហ្គេម", image: "/promotions/10-slot.jpg", term: 4},
					{id: 15, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ហ្គេមបាញ់ត្រី", image: "/promotions/10-fishing.jpg", term: 4},
					{id: 16, text: "ទឹកប្រាក់បន្ថែម 10% សម្រាប់ឡូតូ", image: "/promotions/10-keno.jpg", term: 4}
				],
				isValid: false,
				loaded: false,
				message: "",
				user: {username: "", password: "", token: "", verification_code: "", code: ""}
			}
		}
	}
</script>
<style>
	.game-list {
		cursor: pointer;
		border-radius: 15px;
		border: 1px solid #135F87;
		text-align: center;
		font-size: 13px;
	}
	.game-list:hover {
		opacity: 0.9;
	}
	.game-list-image {
		border-radius: 15px;
	}
	.page-title {
		background-color: #1c3042;
		padding: 15px 0;
		text-align:center;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		font-size: 15px;
		font-weight: bold;
	}
	.promotion-container {
		display: flex;
		flex-direction: column;
		border-radius: 15px;
		border: 1px solid #135F87;
		margin-bottom: 10px;
	}
	.promotion-image-cover img {
		border-top-right-radius: 15px;
		border-top-left-radius: 15px;
	}
	.promotion-title {
		padding: 10px 10px 0;
		text-align: center;
		font-size: 14px;
	}
	.promotion-button-container {
		display: flex;
		flex-direction: row;
		padding: 10px;
		justify-content: center;
	}
	.promotion-button {
		padding: 5px 20px;
		margin: 0 4px;
		border-radius: 10px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Bet.vue